export default __webpack_public_path__ + "static/media/Tradeo.7fee6c1f.jpg";